﻿import { IDonor } from './donor';

export interface IPotentialDonor extends IDonor {
    isAccepted: boolean;
    isFullyConfident: boolean;
    isReEvalNeeded: boolean;
    previousIsAccepted: boolean | null;
    pairMatchPower: number;
    hasAcceptableXm: boolean;
    hasPendingXm: boolean;
    updatedDonorItems: string;
    singleEpletMmDr: number;
    singleEpletMmDq: number;
    singleEpletMmDqLow: number;
    totalEpletMmDr: number;
    totalEpletMmDq: number;
    daysInNkr: number;
    storedPairMatchPower: number;
    decisionDateTime: Date;
    isAboCompatible: boolean;
    isBiologicalMatch: boolean;
    isBioMatch: boolean; //Both Abo and Hla
    isAvoided: boolean;
    isBadAboMatch: boolean;
    isBadAgeMatch: boolean;
    isAboCutoff: boolean;
    isPediatricAgeCutoff: boolean;
    isInMatch: boolean;
    isHardToMatch: boolean;
    isBadPmpc: boolean;
    isPotentialDonor: boolean;
    isHistoric: boolean;
}
